import React from "react";
import { Box, Typography } from "@mui/material";
import { formatCompactCurrency, formatCurrency } from "../../utils/formatters";
import { tokens } from "../../theme";

/**
 * Recessed figure cell (label + compact USD) used in card footers.
 * `flat` drops the well (dense phone footers where three boxes would read as noise).
 */
export const MiniStat: React.FC<{ label: string; value: number; exact?: string; flat?: boolean }> = ({
  label,
  value,
  exact,
  flat = false,
}) => (
  <Box
    sx={
      flat
        ? { minWidth: 0 }
        : {
            minWidth: 0,
            px: 1.25,
            py: 1,
            borderRadius: "12px",
            bgcolor: tokens.glass.inset,
            border: `1px solid ${tokens.borderSubtle}`,
          }
    }
    title={exact ?? formatCurrency(value)}
  >
    <Typography component="div" noWrap sx={{ fontSize: "0.75rem", color: "text.secondary", lineHeight: 1.4 }}>
      {label}
    </Typography>
    {/* Zero = nothing to show (e.g. no buybacks on Rootstock): a quiet dash, not "$0". */}
    <Typography
      component="div"
      noWrap
      sx={{ fontSize: { xs: "0.875rem", md: "0.9375rem" }, fontWeight: 650, color: value ? "text.primary" : "text.disabled" }}
    >
      {value ? formatCompactCurrency(value) : "—"}
    </Typography>
  </Box>
);

export default MiniStat;
